<template>
  <div>
    <v-row
      class="justify-center">
      <v-col
        cols="10"
        md="8"
        style="max-width: 916px">
        <v-card>
          <v-row>
            <v-col md="6" class="background d-none d-md-flex">
              <v-img
                alt="background"
                src="../../assets/img/views/newPassword/background.jpg"
                contain
                width="300px">
              </v-img>
            </v-col>
            <v-col
              cols="12"
              class="form-container"
              md="6">
              <h1 class="text-center mb-5 mt-5 primary--text">Intercambios</h1>
              <v-form
                lazy-validation
                ref="form"
                v-model="valid"
                class="mr-5 ml-5 mb-5">
                <h3 class="mb-3">{{$t('login.change')}}</h3>
                <p>{{$t('login.changeMessage')}}</p>
                <v-text-field
                  v-model="password"
                  outlined
                  dense
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="rules.validPassword"
                  :type="show ? 'text' : 'password'"
                  :label="$t('login.newPassword')"
                  @keyup.enter="recoverPassword"
                  @click:append="show = !show"
                ></v-text-field>
                <v-text-field
                  v-model="password2"
                  outlined
                  dense
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="rules.validPassword"
                  :type="show2 ? 'text' : 'password'"
                  :label="$t('login.repeatPassword')"
                  class="mt-3"
                  @keyup.enter="recoverPassword"
                  @click:append="show2 = !show2"
                ></v-text-field>
                <v-row>
                  <v-col>
                    <v-btn
                      color="primary"
                      class="float-right mt-3"
                      @click="recoverPassword">
                      {{$t('general.change')}}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      email: '',
      token: '',
      password2: '',
      show: false,
      show2: false,
      valid: true
    }
  },
  created () {
    this.email = this.$route.query.email
    this.token = this.$route.query.token
  },
  methods: {
    recoverPassword() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('resetPassword', {
          event: {
            context: this,
            params: {
              email: this.email,
              token: this.token,
              password: this.password,
              password_confirmation: this.password2
            }
          }
        })
      }
    }
  },
  props: ['lang'],
  computed: {
    rules () {
      return this.$validationRules()
    }
  }
}
</script>

<style scoped>
  .form-container {
    display: grid !important;
    align-items: center !important;
  }
</style>